module.exports = __webpack_public_path__ + "ipetbooking-landing/img/logo-menuWhite.16b8985a.svg";